import { ConditionItem } from '@/types/Types'
import Dexie, { Table } from 'dexie'

export class SearchConditionDexie extends Dexie {
  searchConditions!: Table<ConditionItem>

  constructor() {
    super('searchConditionDatabase')
    this.version(1).stores({ searchConditions: '++id, uuid, key, value, enabled' })
  }
}

export const searchConditionDB = new SearchConditionDexie()
